import React from 'react'
import styles from './styles.module.css'
export { ChatComposerEditor } from './Editor'
export type { ChatComposerEditorProps } from './Editor'

/** Presentation only: draft, speech, uploads and transport stay with the caller. */
export const ChatComposer: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => (
  <div {...props} className={[styles.composer, className].filter(Boolean).join(' ')} />
)
export const ChatComposerActions: React.FC = ({ children }) => <div className={styles.actions}>{children}</div>
export const ChatComposerActionGroup: React.FC = ({ children }) => <div className={styles.group}>{children}</div>
export const ChatComposerHint: React.FC = ({ children }) => <div className={styles.hint}>{children}</div>
